export const BanknotesIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <g>
        <path
          d="M22.5 17.5L23.0779 19.9837L19.4157 18.4682C17.2066 17.554 14.663 18.0856 13.0049 19.8081C11.3469 21.5306 8.80329 22.0622 6.59414 21.148L2.93195 19.6325L1.6502 13.5M1 13L4.66667 15.5C6.87851 17.0081 9.78816 17.0081 12 15.5C14.2118 13.9919 17.1215 13.9919 19.3333 15.5L23 18V7L19.3333 4.5C17.1215 2.99192 14.2118 2.99192 12 4.5C9.78815 6.00808 6.87851 6.00808 4.66667 4.5L1 2L1 13ZM14 10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
